<template>
  <div class="flex col-12 mb1 white-bg p2 my2 lighter-elevate pointer" @click="goToOrderDetails(order.uuid)">
    <div class="flex flex-wrap col-11">
      <div class="flex col-12 h6n">Date d'achat: {{ date }}</div>
      <div class="flex flex-wrap col-12 my4">
        <div class="flex col-12 justify-center bold center h5n">{{ siteName }}</div>
        <div class="flex col-12 justify-center center h5n">{{ order.order.order_items[0].product_name }}</div>
      </div>
      <div class="flex col-12 h6n">Nº de commande: {{ uuid }}</div>
    </div>
    <div class="flex col-1 justify-end items-center h1n">
      <i class="icon icon-chevron-right"></i>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue';
import { format } from 'date-fns';
import { useRouter } from 'vue-router';

export default {
  props: {
    order: {
      type: Object,
      required: true
    },
    siteName: {
      type: String,
      required: true
    }
  },
  setup (props) {
    const router = useRouter();

    const date = ref(format(new Date(props.order.date), 'dd/MM/yyyy'));

    const formatUUID = uuid => uuid.replace('order_generic_', '');
    const uuid = ref(formatUUID(props.order.uuid));

    const goToOrderDetails = u => {
      router.replace({ name: 'OrderDetails', params: { uuid: u } });
    };
    return { formatUUID, goToOrderDetails, date, uuid };
  }
};
</script>

<style>

</style>
